import * as constants from '../constants/constants';
import { axiosCaller } from "../utils/apiCaller";
import {setButtonLoading, setLoading, wrap} from './generalActions'
import {toast} from "react-toastify";
import {translatedText} from "../components/TranslatedText"

export const getInstallationRecords = (query?, startDate?, endDate?, page = 1, perPage = 20, search = '') => wrap(async(dispatch:any) => {
    try {
        dispatch(setLoading(true))
        dispatch(setButtonLoading(true));

        let queryParams: string[] = [];
        if (query) queryParams.push(query);
        if (startDate && endDate) {
            queryParams.push(`startDate=${startDate}`);
            queryParams.push(`endDate=${endDate}`);
        }
        queryParams.push(`page=${page}`);
        queryParams.push(`per_page=${perPage}`);
        if (search) queryParams.push(`search=${encodeURIComponent(search)}`);
        const queryString = queryParams.length > 0 ? `?${queryParams.join('&')}` : '';

        return await axiosCaller('GET', `installations/transports${queryString}`).then(res => {
            dispatch(setLoading(false))
            dispatch(setButtonLoading(false));
            dispatch({ "type": constants.FETCH_INSTALLATION_RECORDS, "payload": res.data });
        })
    } catch(err) {
    }
}, 'FETCH_EQUIPMENTS')

export const getProjectsReadyForInstallation = () => wrap(async(dispatch:any) => {
    try {
        return await axiosCaller('GET', `installations`).then(res => {
            dispatch({ "type": constants.FETCH_PROJECTS_FOR_INSTALLATION, "payload": res.data.data });
        })
    } catch(err) {
    }
}, 'FETCH_EQUIPMENTS')

export const getInstallationRecordsForMap = () => wrap(async(dispatch:any) => {
    try {
        return await axiosCaller('GET', `installations/map`).then(res => {

            dispatch({ "type": constants.FETCH_INSTALLATION_RECORDS_FOR_MAP, "payload": res.data.data });
        })
    } catch(err) {
    }
}, 'FETCH_EQUIPMENTS')

export const getInstallationRecordByProjectId = (projectId: number) => wrap(async(dispatch:any) => {
    try {
        return await axiosCaller('GET', `installations/${projectId}/project`).then(res => {
            dispatch({ "type": constants.FETCH_INSTALLATION_RECORD_BY_PROJECT_ID, "payload": res.data.data });
        })
    } catch(err) {
    }
}, 'FETCH_EQUIPMENTS')


export const getInstallationRecordByTransportId = (transportId: number) => wrap(async(dispatch:any) => {
    try {
        dispatch(setLoading(true))
        dispatch(setButtonLoading(true));
        return await axiosCaller('GET', `installations/${transportId}/transport`).then(res => {
            dispatch(setLoading(false))
            dispatch(setButtonLoading(false));
            dispatch({ "type": constants.FETCH_INSTALLATION_RECORD_BY_TRANSPORT_ID, "payload": res.data.data });
        })
    } catch(err) {
    }
}, 'FETCH_EQUIPMENTS')

// Same error-extraction logic as measures.tsx. Kept inline (rather than a shared util) because
// each module's action file already imports differently and the function is tiny.
const extractInstallationErrorMessage = (err: any, fallback: string): string => {
    const data = err?.response?.data;
    if (data?.errors && typeof data.errors === 'object') {
        const first = Object.values(data.errors)[0] as any;
        if (Array.isArray(first) && first.length) return first[0];
        if (typeof first === 'string') return first;
    }
    if (typeof data?.message === 'string' && data.message) return data.message;
    if (err?.response?.status === 413) return 'File too large for server upload limit';
    if (typeof err?.message === 'string' && err.message) return err.message;
    return fallback;
};

export const createInstallationRecord = (payload) => wrap(async(dispatch:any) => {
    try {
        dispatch(setLoading(true))
        dispatch(setButtonLoading(true));
        return await axiosCaller('POST', `installations`, payload).then(res => {
            toast.success(translatedText({id:"installationCreated",defaultMessage:"Instalimi u krijua me sukses"}))
            dispatch(setLoading(false))
            dispatch(setButtonLoading(false));
        })
    } catch(err) {
        // Previously this catch was empty → silent failure on validation / size-limit errors.
        // Reset loading state and surface the actual server message (e.g. video size cap, MIME
        // rejection) so the user knows what went wrong instead of staring at an infinite spinner.
        dispatch(setLoading(false))
        dispatch(setButtonLoading(false));
        toast.error(extractInstallationErrorMessage(err, translatedText({id:"somethingWentWrong",defaultMessage:"Diqka nuk shkoi mire"})));
    }
}, 'FETCH_EQUIPMENTS')


export const editInstallationRecord = (payload, id) => wrap(async(dispatch:any) => {
    try {
        dispatch(setLoading(true))
        dispatch(setButtonLoading(true));
        return await axiosCaller('POST', `installations/${id}`, payload).then(res => {
            toast.success(translatedText({id:"installationUpdated",defaultMessage:"Instalimi u editua me sukses"}))
            dispatch(setLoading(false))
            dispatch(setButtonLoading(false));
        })
    } catch(err) {
        dispatch(setLoading(false))
        dispatch(setButtonLoading(false));
        toast.error(extractInstallationErrorMessage(err, translatedText({id:"somethingWentWrong",defaultMessage:"Diqka nuk shkoi mire"})));
    }
}, 'FETCH_EQUIPMENTS')

export const deleteInstallationFile = (fileId) => wrap(async(dispatch:any) => {
    try {
        return await axiosCaller('DELETE', `installations/${fileId}/assets`).then(res => {
            toast.info(translatedText({id:"installationFileDeleted",defaultMessage:"Dosja u fshi me sukses!"}))
        })
    } catch(err) {
    }
}, 'FETCH_EQUIPMENTS')

export const deleteInstallationRecord = (serviceId) => wrap(async(dispatch:any) => {
    try {
        return await axiosCaller('DELETE', `installations/${serviceId}`).then(res => {
            toast.info(translatedText({id:"installationDeleted",defaultMessage:"Instalimi u fshi me sukses!"}))
        })
    } catch(err) {
    }
}, 'FETCH_EQUIPMENTS')

// =====================
// NEW ACTIONS
// =====================

export const fetchInstallationStats = () => wrap(async(dispatch:any) => {
    try {
        return await axiosCaller('GET', `installation/dashboard-stats`).then(res => {
            dispatch({ "type": constants.FETCH_INSTALLATION_DASHBOARD_STATS_NEW, "payload": res.data.data });
            return res.data.data;
        })
    } catch(err) {}
}, 'FETCH_INSTALLATION_STATS')

export const fetchInstallations = (filters: any = {}) => wrap(async(dispatch:any) => {
    try {
        dispatch(setLoading(true));
        const params: string[] = [];
        if (filters.status) params.push(`status=${filters.status}`);
        if (filters.city) params.push(`city=${encodeURIComponent(filters.city)}`);
        if (filters.search) params.push(`search=${encodeURIComponent(filters.search)}`);
        if (filters.start_date) params.push(`start_date=${filters.start_date}`);
        if (filters.end_date) params.push(`end_date=${filters.end_date}`);
        if (filters.page) params.push(`page=${filters.page}`);
        if (filters.per_page !== undefined) params.push(`per_page=${filters.per_page}`);

        return await axiosCaller('GET', `installation?${params.join('&')}`).then(res => {
            dispatch(setLoading(false));
            dispatch({ "type": constants.FETCH_INSTALLATIONS_NEW, "payload": res.data });
            return res.data;
        })
    } catch(err) { dispatch(setLoading(false)); }
}, 'FETCH_INSTALLATIONS')

export const fetchInstallation = (installationId: number) => wrap(async(dispatch:any) => {
    try {
        return await axiosCaller('GET', `installation/${installationId}`).then(res => {
            dispatch({ "type": constants.FETCH_INSTALLATION_NEW, "payload": res.data.data });
            return res.data.data;
        })
    } catch(err) {}
}, 'FETCH_INSTALLATION')

export const fetchWaiting = (filters: any = {}) => wrap(async(dispatch:any) => {
    try {
        dispatch(setLoading(true));
        const params: string[] = [];
        if (filters.search) params.push(`search=${encodeURIComponent(filters.search)}`);
        if (filters.city) params.push(`city=${encodeURIComponent(filters.city)}`);
        if (filters.overdue_only) params.push(`overdue_only=1`);
        if (filters.page) params.push(`page=${filters.page}`);
        if (filters.per_page !== undefined) params.push(`per_page=${filters.per_page}`);

        return await axiosCaller('GET', `installation/waiting?${params.join('&')}`).then(res => {
            dispatch(setLoading(false));
            dispatch({ "type": constants.FETCH_INSTALLATION_WAITING_NEW, "payload": res.data });
            return res.data;
        })
    } catch(err) { dispatch(setLoading(false)); }
}, 'FETCH_INSTALLATION_WAITING')

export const fetchWaitingItem = (transportItemId: number) => wrap(async(dispatch:any) => {
    try {
        return await axiosCaller('GET', `installation/waiting/${transportItemId}`).then(res => {
            return res.data.data;
        })
    } catch(err) {}
}, 'FETCH_WAITING_ITEM')

export const fetchWaitingWr = (warehouseRecordId: number) => wrap(async(dispatch:any) => {
    try {
        return await axiosCaller('GET', `installation/waiting-wr/${warehouseRecordId}`).then(res => {
            return res.data.data;
        })
    } catch(err) {}
}, 'FETCH_WAITING_WR')

export const createInstallation = (payload: any) => wrap(async(dispatch:any) => {
    try {
        return await axiosCaller('POST', `installation`, payload).then(res => {
            return res.data;
        })
    } catch(err) {}
}, 'CREATE_INSTALLATION')

export const fetchWithoutInstallation = (filters: any = {}) => wrap(async(dispatch:any) => {
    try {
        dispatch(setLoading(true));
        const params: string[] = [];
        if (filters.search) params.push(`search=${encodeURIComponent(filters.search)}`);
        if (filters.page) params.push(`page=${filters.page}`);
        if (filters.per_page !== undefined) params.push(`per_page=${filters.per_page}`);

        return await axiosCaller('GET', `installation/without-installation?${params.join('&')}`).then(res => {
            dispatch(setLoading(false));
            dispatch({ "type": constants.FETCH_WITHOUT_INSTALLATION, "payload": res.data.data });
            return res.data.data;
        })
    } catch(err) { dispatch(setLoading(false)); }
}, 'FETCH_WITHOUT_INSTALLATION')

export const fetchWithoutInstallationItem = (id: number, source: string) => wrap(async(dispatch:any) => {
    try {
        return await axiosCaller('GET', `installation/without-installation-item/${id}?source=${source}`).then(res => {
            return res.data.data;
        })
    } catch(err) {}
}, 'FETCH_WITHOUT_INSTALLATION_ITEM')

export const createWithoutInstallation = (payload: any) => wrap(async(dispatch:any) => {
    try {
        return await axiosCaller('POST', `installation/without-installation`, payload).then(res => {
            return res.data;
        })
    } catch(err) {}
}, 'CREATE_WITHOUT_INSTALLATION')

export const blockInstallation = (installationId: number, payload: { block_category_id?: number; block_type_id?: number; block_reason?: string }) => wrap(async(dispatch:any) => {
    try {
        return await axiosCaller('PATCH', `installation/${installationId}/block`, payload).then(res => {
            if (res.data.error) return res.data;
            dispatch({ "type": constants.FETCH_INSTALLATION_NEW, "payload": res.data.data });
            return res.data;
        })
    } catch(err) { return err?.response?.data; }
}, 'BLOCK_INSTALLATION')

export const resumeInstallation = (installationId: number) => wrap(async(dispatch:any) => {
    try {
        return await axiosCaller('PATCH', `installation/${installationId}/resume`).then(res => {
            if (res.data.error) return res.data;
            dispatch({ "type": constants.FETCH_INSTALLATION_NEW, "payload": res.data.data });
            return res.data;
        })
    } catch(err) { return err?.response?.data; }
}, 'RESUME_INSTALLATION')

export const leaveInstallation = (installationId: number) => wrap(async(dispatch:any) => {
    try {
        return await axiosCaller('PATCH', `installation/${installationId}/leave`).then(res => {
            if (res.data.error) return res.data;
            dispatch({ "type": constants.FETCH_INSTALLATION_NEW, "payload": res.data.data });
            return res.data;
        })
    } catch(err) { return err?.response?.data; }
}, 'LEAVE_INSTALLATION')

export const finishInstallation = (installationId: number) => wrap(async(dispatch:any) => {
    try {
        return await axiosCaller('PATCH', `installation/${installationId}/finish`).then(res => {
            if (res.data.error) return res.data;
            dispatch({ "type": constants.FETCH_INSTALLATION_NEW, "payload": res.data.data });
            return res.data;
        })
    } catch(err) { return err?.response?.data; }
}, 'FINISH_INSTALLATION')

export const uploadInstallationFiles = (installationId: number, formData: FormData) => wrap(async(dispatch:any) => {
    try {
        return await axiosCaller('POST', `installation/${installationId}/files`, formData).then(res => {
            return res.data;
        })
    } catch(err) {
        toast.error(extractInstallationErrorMessage(err, translatedText({id:"somethingWentWrong",defaultMessage:"Diqka nuk shkoi mire"})));
    }
}, 'UPLOAD_INSTALLATION_FILES')

export const deleteInstallationFileNew = (installationId: number, fileId: number) => wrap(async(dispatch:any) => {
    try {
        return await axiosCaller('DELETE', `installation/${installationId}/files/${fileId}`).then(res => {
            return res.data;
        })
    } catch(err) {}
}, 'DELETE_INSTALLATION_FILE')

export const deleteInstallationFilesNew = (installationId: number, fileIds: number[]) => wrap(async(dispatch:any) => {
    try {
        return await axiosCaller('POST', `installation/${installationId}/files/bulk-delete`, { file_ids: fileIds }).then(res => {
            return res.data;
        })
    } catch(err) {}
}, 'DELETE_INSTALLATION_FILES')

export const addInstallationComment = (installationId: number, text: string) => wrap(async(dispatch:any) => {
    try {
        return await axiosCaller('POST', `installation/${installationId}/comments`, { text }).then(res => {
            return res.data;
        })
    } catch(err) {}
}, 'ADD_INSTALLATION_COMMENT')

export const fetchInstallationLocations = (filters: any = {}) => wrap(async(dispatch:any) => {
    try {
        const params: string[] = [];
        if (filters.status) params.push(`status=${filters.status}`);
        const url = `installation/locations${params.length ? '?' + params.join('&') : ''}`;

        return await axiosCaller('GET', url).then(res => {
            dispatch({ "type": constants.FETCH_INSTALLATION_LOCATIONS_NEW, "payload": res.data.data });
            return res.data.data;
        })
    } catch(err) {}
}, 'FETCH_INSTALLATION_LOCATIONS')